import { render, staticRenderFns } from "./LoyaltyUpgrades.vue?vue&type=template&id=37b245f7&"
import script from "./LoyaltyUpgrades.vue?vue&type=script&lang=js&"
export * from "./LoyaltyUpgrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports